'use strict';

angular.module('tcApp')
.config(function($rootScopeProvider) {
	// Because we have nested templates in layoutEdit/block.html,
	// more than 10 digest cycles are needed
	// https://groups.google.com/forum/#!topic/angular/Fn8ujAx2OP4
	$rootScopeProvider.digestTtl(15);
});
